import { render, staticRenderFns } from "./BillingDateRule.yaml?vue&type=template&id=c2181702&component"
import script from "./BillingDateRule.yaml?vue&type=script&lang=ts&component"
export * from "./BillingDateRule.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports